<template>

    <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
    </a>
  <!--<header>-->
    <!--<b-navbar toggleable="md" type="light" variant="light">-->

      <!--<b-navbar-brand href="#">{{$t('title')}}</b-navbar-brand>-->

      <!--<a href="#" data-target="#sidebar" data-toggle="collapse"><i class="fa fa-navicon py-2 p-1"></i></a>-->

      <!--<b-collapse is-nav id="nav_collapse">-->
        <!--<b-navbar-nav class="ml-auto">-->
          <!--<b-nav-item-dropdown right>-->
            <!--<template slot="button-content">-->
              <!--<em>{{ username }}</em>-->
            <!--</template>-->
            <!--<a href="#" @click="SignOut" class="dropdown-item">{{$t('auth.signout')}}</a>-->
          <!--</b-nav-item-dropdown>-->
        <!--</b-navbar-nav>-->
      <!--</b-collapse>-->
    <!--</b-navbar>-->
  <!--</header>-->

  <!--<nav class="navbar navbar-static-top" role="navigation">-->
    <!--&lt;!&ndash; Sidebar toggle button&ndash;&gt;-->
    <!--<a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">-->
      <!--<span class="sr-only">Toggle navigation</span>-->
    <!--</a>-->
    <!--&lt;!&ndash; Navbar Right Menu &ndash;&gt;-->
    <!--<div class="navbar-custom-menu">-->
      <!--<ul class="nav navbar-nav">-->
        <!--&lt;!&ndash; Messages: style can be found in dropdown.less&ndash;&gt;-->
        <!--&lt;!&ndash;<li class="dropdown messages-menu">&ndash;&gt;-->
          <!--&lt;!&ndash;&lt;!&ndash; Menu toggle button &ndash;&gt;&ndash;&gt;-->
          <!--&lt;!&ndash;<a href="#" class="dropdown-toggle" data-toggle="dropdown">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="fa fa-envelope-o"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;<span class="label label-success">4</span>&ndash;&gt;-->
          <!--&lt;!&ndash;</a>&ndash;&gt;-->
          <!--&lt;!&ndash;<ul class="dropdown-menu">&ndash;&gt;-->
            <!--&lt;!&ndash;<li class="header">You have 4 messages</li>&ndash;&gt;-->
            <!--&lt;!&ndash;<li>&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash; inner menu: contains the messages &ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;<ul class="menu">&ndash;&gt;-->
                <!--&lt;!&ndash;<li>&lt;!&ndash; start message &ndash;&gt;&ndash;&gt;-->
                  <!--&lt;!&ndash;<a href="#">&ndash;&gt;-->
                    <!--&lt;!&ndash;<div class="pull-left">&ndash;&gt;-->
                      <!--&lt;!&ndash;&lt;!&ndash; User Image &ndash;&gt;&ndash;&gt;-->
                      <!--&lt;!&ndash;<img src="dist/img/user2-160x160.jpg" class="img-circle" alt="User Image">&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;&lt;!&ndash; Message title and timestamp &ndash;&gt;&ndash;&gt;-->
                    <!--&lt;!&ndash;<h4>&ndash;&gt;-->
                      <!--&lt;!&ndash;Support Team&ndash;&gt;-->
                      <!--&lt;!&ndash;<small><i class="fa fa-clock-o"></i> 5 mins</small>&ndash;&gt;-->
                    <!--&lt;!&ndash;</h4>&ndash;&gt;-->
                    <!--&lt;!&ndash;&lt;!&ndash; The message &ndash;&gt;&ndash;&gt;-->
                    <!--&lt;!&ndash;<p>Why not buy a new awesome theme?</p>&ndash;&gt;-->
                  <!--&lt;!&ndash;</a>&ndash;&gt;-->
                <!--&lt;!&ndash;</li>&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash; end message &ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;</ul>&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash; /.menu &ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;</li>&ndash;&gt;-->
            <!--&lt;!&ndash;<li class="footer"><a href="#">See All Messages</a></li>&ndash;&gt;-->
          <!--&lt;!&ndash;</ul>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash; /.messages-menu &ndash;&gt;-->

        <!--&lt;!&ndash; Notifications Menu &ndash;&gt;-->
        <!--&lt;!&ndash;<li class="dropdown notifications-menu">&ndash;&gt;-->
          <!--&lt;!&ndash;&lt;!&ndash; Menu toggle button &ndash;&gt;&ndash;&gt;-->
          <!--&lt;!&ndash;<a href="#" class="dropdown-toggle" data-toggle="dropdown">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="fa fa-bell-o"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;<span class="label label-warning">10</span>&ndash;&gt;-->
          <!--&lt;!&ndash;</a>&ndash;&gt;-->
          <!--&lt;!&ndash;<ul class="dropdown-menu">&ndash;&gt;-->
            <!--&lt;!&ndash;<li class="header">You have 10 notifications</li>&ndash;&gt;-->
            <!--&lt;!&ndash;<li>&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash; Inner Menu: contains the notifications &ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;<ul class="menu">&ndash;&gt;-->
                <!--&lt;!&ndash;<li>&lt;!&ndash; start notification &ndash;&gt;&ndash;&gt;-->
                  <!--&lt;!&ndash;<a href="#">&ndash;&gt;-->
                    <!--&lt;!&ndash;<i class="fa fa-users text-aqua"></i> 5 new members joined today&ndash;&gt;-->
                  <!--&lt;!&ndash;</a>&ndash;&gt;-->
                <!--&lt;!&ndash;</li>&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash; end notification &ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;</ul>&ndash;&gt;-->
            <!--&lt;!&ndash;</li>&ndash;&gt;-->
            <!--&lt;!&ndash;<li class="footer"><a href="#">View all</a></li>&ndash;&gt;-->
          <!--&lt;!&ndash;</ul>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash; Tasks Menu &ndash;&gt;-->
        <!--&lt;!&ndash;<li class="dropdown tasks-menu">&ndash;&gt;-->
          <!--&lt;!&ndash;&lt;!&ndash; Menu Toggle Button &ndash;&gt;&ndash;&gt;-->
          <!--&lt;!&ndash;<a href="#" class="dropdown-toggle" data-toggle="dropdown">&ndash;&gt;-->
            <!--&lt;!&ndash;<i class="fa fa-flag-o"></i>&ndash;&gt;-->
            <!--&lt;!&ndash;<span class="label label-danger">9</span>&ndash;&gt;-->
          <!--&lt;!&ndash;</a>&ndash;&gt;-->
          <!--&lt;!&ndash;<ul class="dropdown-menu">&ndash;&gt;-->
            <!--&lt;!&ndash;<li class="header">You have 9 tasks</li>&ndash;&gt;-->
            <!--&lt;!&ndash;<li>&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash; Inner menu: contains the tasks &ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;<ul class="menu">&ndash;&gt;-->
                <!--&lt;!&ndash;<li>&lt;!&ndash; Task item &ndash;&gt;&ndash;&gt;-->
                  <!--&lt;!&ndash;<a href="#">&ndash;&gt;-->
                    <!--&lt;!&ndash;&lt;!&ndash; Task title and progress text &ndash;&gt;&ndash;&gt;-->
                    <!--&lt;!&ndash;<h3>&ndash;&gt;-->
                      <!--&lt;!&ndash;Design some buttons&ndash;&gt;-->
                      <!--&lt;!&ndash;<small class="pull-right">20%</small>&ndash;&gt;-->
                    <!--&lt;!&ndash;</h3>&ndash;&gt;-->
                    <!--&lt;!&ndash;&lt;!&ndash; The progress bar &ndash;&gt;&ndash;&gt;-->
                    <!--&lt;!&ndash;<div class="progress xs">&ndash;&gt;-->
                      <!--&lt;!&ndash;&lt;!&ndash; Change the css width attribute to simulate progress &ndash;&gt;&ndash;&gt;-->
                      <!--&lt;!&ndash;<div class="progress-bar progress-bar-aqua" style="width: 20%" role="progressbar"&ndash;&gt;-->
                           <!--&lt;!&ndash;aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">&ndash;&gt;-->
                        <!--&lt;!&ndash;<span class="sr-only">20% Complete</span>&ndash;&gt;-->
                      <!--&lt;!&ndash;</div>&ndash;&gt;-->
                    <!--&lt;!&ndash;</div>&ndash;&gt;-->
                  <!--&lt;!&ndash;</a>&ndash;&gt;-->
                <!--&lt;!&ndash;</li>&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash; end task item &ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;</ul>&ndash;&gt;-->
            <!--&lt;!&ndash;</li>&ndash;&gt;-->
            <!--&lt;!&ndash;<li class="footer">&ndash;&gt;-->
              <!--&lt;!&ndash;<a href="#">View all tasks</a>&ndash;&gt;-->
            <!--&lt;!&ndash;</li>&ndash;&gt;-->
          <!--&lt;!&ndash;</ul>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash; User Account Menu &ndash;&gt;-->
        <!--&lt;!&ndash;<li class="dropdown user user-menu">&ndash;&gt;-->
          <!--&lt;!&ndash;&lt;!&ndash; Menu Toggle Button &ndash;&gt;&ndash;&gt;-->
          <!--&lt;!&ndash;<a href="#" class="dropdown-toggle" data-toggle="dropdown">&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash; The user image in the navbar&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash;<img src="dist/img/user2-160x160.jpg" class="user-image" alt="User Image">&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash; hidden-xs hides the username on small devices so only the image appears. &ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;<span class="hidden-xs">{{ username }}</span>&ndash;&gt;-->
          <!--&lt;!&ndash;</a>&ndash;&gt;-->
          <!--&lt;!&ndash;<ul class="dropdown-menu">&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash; The user image in the menu &ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash;<li class="user-header">&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash;<img src="dist/img/user2-160x160.jpg" class="img-circle" alt="User Image">&ndash;&gt;&ndash;&gt;&ndash;&gt;-->

              <!--&lt;!&ndash;&lt;!&ndash;<p>&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;Alexander Pierce - Web Developer&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;<small>Member since Nov. 2012</small>&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash;</p>&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash; Menu Body &ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash;<li class="user-body">&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash;<div class="row">&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;<div class="col-xs-4 text-center">&ndash;&gt;&ndash;&gt;-->
                  <!--&lt;!&ndash;&lt;!&ndash;<a href="#">Followers</a>&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;<div class="col-xs-4 text-center">&ndash;&gt;&ndash;&gt;-->
                  <!--&lt;!&ndash;&lt;!&ndash;<a href="#">Sales</a>&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;<div class="col-xs-4 text-center">&ndash;&gt;&ndash;&gt;-->
                  <!--&lt;!&ndash;&lt;!&ndash;<a href="#">Friends</a>&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash;&lt;!&ndash; /.row &ndash;&gt;&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash;</li>&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;&lt;!&ndash; Menu Footer&ndash;&gt;&ndash;&gt;-->
            <!--&lt;!&ndash;<li class="user-footer">&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash;<div class="pull-left">&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;&lt;!&ndash;<a href="#" class="btn btn-default btn-flat">Profile</a>&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;&lt;!&ndash;</div>&ndash;&gt;&ndash;&gt;-->
              <!--&lt;!&ndash;<div class="pull-right">&ndash;&gt;-->
                <!--&lt;!&ndash;<a href="#" class="btn btn-default btn-flat" @click.prevent="SignOut">{{$t('auth.signout')}}</a>&ndash;&gt;-->
              <!--&lt;!&ndash;</div>&ndash;&gt;-->
            <!--&lt;!&ndash;</li>&ndash;&gt;-->
          <!--&lt;!&ndash;</ul>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
        <!--&lt;!&ndash; Control Sidebar Toggle Button &ndash;&gt;-->
        <!--&lt;!&ndash;<li>&ndash;&gt;-->
          <!--&lt;!&ndash;<a href="#" data-toggle="control-sidebar"><i class="fa fa-gears"></i></a>&ndash;&gt;-->
        <!--&lt;!&ndash;</li>&ndash;&gt;-->
      <!--</ul>-->
    <!--</div>-->
  <!--</nav>-->
</template>

<script>
export default {
  name: 'HeaderSlot',
  data () {
    return {
    }
  },
  computed: {
    username () {
      return this.$store.getters['auth/jwtDecoded']['name']
    },
    language () {
      return this.$store.getters['auth/language']
    }
  },
  methods: {
    SignOut () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$i18n.locale = this.language
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
